import { render, staticRenderFns } from "./addPayAccount.vue?vue&type=template&id=3ffac63e&"
import script from "./addPayAccount.vue?vue&type=script&lang=js&"
export * from "./addPayAccount.vue?vue&type=script&lang=js&"
import style0 from "./addPayAccount.vue?vue&type=style&index=0&id=3ffac63e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports